export default __webpack_public_path__ + "static/media/cafe.6b078a1a.jpg";